
<div class="container DUMMY delete">
  <h1 mat-dialog-title>DUMMY<button mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button></h1>
  <mat-dialog-content>DUMMY</mat-dialog-content>
  <mat-dialog-actions align="end"><button mat-raised-button type="button" [disabled]="true">DUMMY</button></mat-dialog-actions>
</div>